import { useConfig } from '@hooks/useConfig.tsx';

interface SidebarChildren {
  link: string;
  name: string;
  target?: string;
}

interface SidebarProps {
  name: string;
  icon?: string;
  link?: string;
  target?: string;
  children?: SidebarChildren[];
}

export function useSidebarLoader() {
  const { sidebars } = useConfig();
  return {
    // @ts-ignore
    data: sidebars[0] as unknown as SidebarProps[],
  };
}
